module.exports = __webpack_public_path__ + "i18n/zh-CN.296157c2a93ae918c23df82aeed40b90.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/zh-CN.json
// module id = 1005
// module chunks = 60